import { matrixCreator } from '../../helpers/matrixCreator';
import { FieldBorderStyle, FieldImageType, MatrixTypes } from '../../enums/GameEnums';
import { detectFieldColor } from '../../helpers/detectFieldColor';
import { isMobile } from '@pascal/pascal-core';
import { useGamePad } from '../../module/hooks/useGamePad';

export const Matrix = ({matrixType, odds, matrix, isHistory = false, fieldsColor = null}) => {

  const { handleFieldClick } = useGamePad()
  return (matrix || matrixCreator(MatrixTypes[matrixType])).map((el, rowIndex) => {
    const fieldStyle = fieldsColor ? fieldsColor[rowIndex] : detectFieldColor(rowIndex)
    return <div className={`${isMobile() ? 'mob-mines-right-square-row' : 'm-game-mid-row-wrp'}`} key={rowIndex}>
      <div className='m-g-btn-coef-item-wrp'>
        <div className='m-g-btn-item-holder'>
          <p className='m-g-btn-item-coef'>x{odds ? odds[rowIndex] : ''}</p>
        </div>
        <div className={`m-g-btn-item-bg type-${fieldStyle}`} />
      </div>
      {
        el.map((type, columnIndex) => {
          const typeProps = FieldImageType[type]
          return (
            <div className='m-game-mid-row-block' key={columnIndex} onClick={isHistory ? null : () => handleFieldClick(columnIndex, rowIndex)}>
              {fieldStyle === FieldBorderStyle.current ? <div className='start-animation'/> : null}
              <div className='m-game-mid-row-block-inner'>
                <div className={`m-game-mid-row-block-${typeProps.type || ''}-wrp`}>
                  <img src={typeProps.src} className={`img-${typeProps.type}`} alt='' />
                </div>
              </div>
              <div className={`m-game-mid-row-block-bg type-${fieldStyle}`} />
            </div>
          );
        })}
    </div>;
  })
}